<form [formGroup]="formGroup" (ngSubmit)="submit()">
  <box class="entry-form dynamic-form">
    <box class="field-group">
      <ng-container *ngFor="let control of formConfig">
        <box class="field-set">
          <ng-container [ngSwitch]="control.fieldType">
            <ng-container *ngSwitchCase="'textBox'">
              <fpx-text-box [label]="control.label" [placeholder]="control.placeholder"
                [formControlName]="control.formControlName"
                [hint]="control.hint">
              </fpx-text-box>
            </ng-container>
            <ng-container *ngSwitchCase="'comboBox'">
              <fpx-selectable-dropdown [label]="control.label" [placeholder]="control.placeholder"
                [formControlName]="control.formControlName">
              </fpx-selectable-dropdown>
            </ng-container>
            <ng-container *ngSwitchCase="'checkBox'"> </ng-container>
            <ng-container *ngSwitchCase="'radioButton'">
              <fpx-radio-button [label]="control.label" [placeholder]="control.placeholder"
                [formControlName]="control.formControlName"></fpx-radio-button>
            </ng-container>
            <ng-container *ngSwitchCase="'date'">
              <fpx-date [label]="control.label" [placeholder]="control.placeholder"
                [formControlName]="control.formControlName"></fpx-date>
            </ng-container>
          </ng-container>
        </box>
      </ng-container>
    </box>
  </box>
</form>